'use client'

import './style.css'
import { inter, robotoMono } from '@/app/fonts'
import Scripts from '@/app/layout/scripts'
import BugsnagWrapper from '@/app/layout/bugsnag'
import BrowserOnly from '@/app/layout/BrowserOnly'

interface ClientWrapperProps {
  children: React.ReactNode
  nonce: string
}

const ClientWrapper: React.FC<ClientWrapperProps> = ({ children, nonce }) => {
  return (
    <BugsnagWrapper>
      <html className={`${inter.variable} ${robotoMono.variable}`}>
        <head>
          <title>SeDomicilier</title>
          <meta name='robots' content='noindex,nofollow' />
          <meta name='googlebot' content='noindex,nofollow' />
          <meta name='viewport' content='width=device-width, initial-scale=1' />
          <meta name='google' content='nositelinkssearchbox' key='sitelinks' />
          <meta name='google' content='notranslate' key='notranslate' />
          <Scripts nonce={nonce} />
        </head>
        <body className='flex min-h-dvh flex-col bg-white commanderImg'>
          <BrowserOnly>{children}</BrowserOnly>
        </body>
      </html>
    </BugsnagWrapper>
  )
}

export default ClientWrapper
